module.exports = __webpack_public_path__ + "static/media/hryvnia.e67efa04.svg";